module.exports = __webpack_public_path__ + "media/one-coin1.500ec1ad.mp3";